/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Delete_File_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to delete file. Please try again." |
*
* @param {Spaces_Delete_File_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_delete_file_error = /** @type {((inputs?: Spaces_Delete_File_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Delete_File_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen der Datei. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Failed to delete file. Please try again.")
});